<div class="importContainer">
  <div class="rankingSet" >
    <div style="width: 100%;">
      <div class="right">Position</div>
      <div class="left">Roaster Construction</div>
      <hr>
    </div>
    <form #roasterContract = "ngForm" (ngSubmit) = "saveConstrct(roasterContract.value)">
    <div class="row" *ngFor="let climit of mydata">
      <label class="right">
        {{climit.key}}
      </label>
      <div class="input">
        <input type="number" name="{{climit.key}}" value="{{climit.value}}" [(ngModel)]="climit.value" (keypress)="keyPressNumbers($event)" >
        <!--input type="text" [name]="'data_' + climit.key" value="{{climit.value}}" [(ngModel)]="climit.key" -->
        <!--input type="text" [usersData]="{{climit.key}}" value="{{climit.value}}" -->
      </div>
    </div>
    <br>
      <button mat-raised-button class="submit">Submit</button>
    </form>
  </div>
</div>